import apiClient from 'clients/apiClient';
import config from 'helpers/config';

const baseURL = `${ config.getApiBaseUrl() }/transactions`;

export const createTransactionInvoiceRequest = (transactionId) => {
    return apiClient.create(`${ baseURL }/${ transactionId }/invoice`);
};



// WEBPACK FOOTER //
// ./src/http/requests/transactionRequests.js